export function useLayout() {
  const { public: config } = useRuntimeConfig()
  const layoutData = useState('layout', () => null as any)

  const loadLayout = async () => {
    if (!layoutData.value) {
      const { data } = await useAsyncGraphqlQuery('layout', {
        locale: config.strapiLocale,
      }, useGraphqlDefaultClient())
      layoutData.value = data.value?.data || null
    }
  }

  const tooltips = computed<Map<string, any>>(() => {
    const data = new Map<string, any>()
    layoutData.value?.tooltips?.forEach((tooltip: any) => {
      data.set(tooltip?.UID, tooltip)
    })
    return data
  })

  return {
    loadLayout,
    layoutData,
    tooltips,
  }
}
